import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CareGuideDocumentForm from '../containers/CareGuideDocumentFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideDocumentEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideDocumentEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) =>
        <div>
          <DocumentHead title={t('care_guide_documents_route_edit')} />
          <CareGuideDocumentForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideDocumentEditScreen;

Logger.log('silly', `CareGuideDocumentEditScreen loaded.`);
